import { render, staticRenderFns } from "./add-patients-to-group-dialog.vue?vue&type=template&id=66e1a51d&scoped=true"
import script from "./add-patients-to-group-dialog.vue?vue&type=script&lang=js"
export * from "./add-patients-to-group-dialog.vue?vue&type=script&lang=js"
import style0 from "./add-patients-to-group-dialog.vue?vue&type=style&index=0&id=66e1a51d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e1a51d",
  null
  
)

export default component.exports